module.exports = __webpack_public_path__ + "img/bg.c8205944.jpg";